import React from 'react';

const TextViewer = ({ selectedDocument, textContent, loading, error }) => {
  if (!selectedDocument && !textContent) {
    return (
      <div className="pdf-viewer">
        <div className="pdf-header">
          <h3>Text Viewer</h3>
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            Select a text document to view
          </div>
        </div>
        <div className="pdf-content">
          <div className="empty-state">
            📝<br/>
            No document selected.<br/>
            Click on a text document from the list to view it here.
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="pdf-viewer">
        <div className="pdf-header">
          <h3>Text Viewer</h3>
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            Loading text document...
          </div>
        </div>
        <div className="pdf-content">
          <div className="pdf-loading">
            Loading text...
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pdf-viewer">
        <div className="pdf-header">
          <h3>Text Viewer</h3>
          <div style={{ fontSize: '0.9rem', color: '#ff4757' }}>
            Error loading document
          </div>
        </div>
        <div className="pdf-content">
          <div className="pdf-error">
            <div>
              ❌<br/>
              Failed to load text document<br/>
              <div style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>
                {error}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-viewer">
      <div className="pdf-header">
        <h3>
          📝 {selectedDocument?.document_name || 'Text Document'}
        </h3>
        {selectedDocument?.metadata?.source_table && selectedDocument?.metadata?.source_id && (
          <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '0.25rem' }}>
            Source: {selectedDocument.metadata.source_table}:{selectedDocument.metadata.source_id}
          </div>
        )}
      </div>

      <div className="pdf-content" style={{ padding: '20px' }}>
        <div style={{
          background: 'white',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          maxWidth: '900px',
          margin: '0 auto',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontSize: '0.95rem',
          lineHeight: '1.7',
          color: '#333'
        }}>
          {textContent ? (
            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {textContent}
            </div>
          ) : loading ? (
            <div style={{
              color: '#667eea',
              textAlign: 'center',
              padding: '40px 20px',
              fontSize: '0.9rem'
            }}>
              Loading text content...
            </div>
          ) : (
            <div style={{
              color: '#999',
              fontStyle: 'italic',
              textAlign: 'center',
              padding: '40px 20px'
            }}>
              No text content available for this document.
              <div style={{ fontSize: '0.85rem', marginTop: '10px' }}>
                {error || 'Unable to retrieve text content from the vector database.'}
              </div>
            </div>
          )}
        </div>

        {(selectedDocument?.metadata || textContent) && (
          <div style={{
            marginTop: '20px',
            padding: '16px',
            background: '#f8f9fa',
            borderRadius: '6px',
            fontSize: '0.8rem',
            color: '#666',
            maxWidth: '900px',
            margin: '20px auto 0'
          }}>
            <div style={{ fontWeight: '600', marginBottom: '8px', color: '#333' }}>
              Document Information
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px 16px' }}>
              {textContent && (
                <>
                  <div style={{ fontWeight: '500' }}>Characters:</div>
                  <div>{textContent.length.toLocaleString()}</div>
                  <div style={{ fontWeight: '500' }}>Words (approx):</div>
                  <div>{Math.round(textContent.split(/\s+/).length).toLocaleString()}</div>
                </>
              )}
              {selectedDocument?.metadata?.source_table && (
                <>
                  <div style={{ fontWeight: '500' }}>Source Table:</div>
                  <div>{selectedDocument.metadata.source_table}</div>
                </>
              )}
              {selectedDocument?.metadata?.source_id && (
                <>
                  <div style={{ fontWeight: '500' }}>Source ID:</div>
                  <div>{selectedDocument.metadata.source_id}</div>
                </>
              )}
              {selectedDocument?.metadata?.timestamp && (
                <>
                  <div style={{ fontWeight: '500' }}>Timestamp:</div>
                  <div>{new Date(selectedDocument.metadata.timestamp).toLocaleString()}</div>
                </>
              )}
              {selectedDocument?.metadata?.timestamp_source && (
                <>
                  <div style={{ fontWeight: '500' }}>Timestamp Source:</div>
                  <div>{selectedDocument.metadata.timestamp_source}</div>
                </>
              )}
              {selectedDocument?.chunk_count && (
                <>
                  <div style={{ fontWeight: '500' }}>Chunks:</div>
                  <div>{selectedDocument.chunk_count}</div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TextViewer;
